import React, { useEffect, useState } from "react";
import ComplaintsComponent from "./complaints";
import "./complaints.scss";
import { societyComplaint } from "../../../../redux/slice/societyComplaintSlice";
import { connect } from "react-redux";
import { Tag, Menu, Tooltip } from "antd";
import { Cookies } from "react-cookie";
import moment from "moment";
import PageLoader from "../../common/pageLoader";
import { dashboardPresidentCount } from "../../../../redux/slice/dashboardPresidentCountSlice";
import { societyList } from "../../../../redux/slice/societyListSlice";

const Complaints = (props) => {
  const {
    societyComplaintData,
    callsocietyComplaintData,
    dashboardPresidentCountData,
    calldashboardPresidentCountData,
    callsocietyListData,
    societyListData,
  } = props;
  const cookies = new Cookies();

  const id = cookies.get("societyId");
  const [searchText, setSearchText] = useState("");
  const complaint_count =
    (dashboardPresidentCountData &&
      dashboardPresidentCountData.dashboardPresidentCountData &&
      dashboardPresidentCountData.dashboardPresidentCountData.data) ||
    null;
  const complaintData =
    (societyComplaintData &&
      societyComplaintData.societyComplaintData &&
      societyComplaintData.societyComplaintData.data &&
      societyComplaintData.societyComplaintData.data.data) ||
    null;

  const totalSocietyList =
    (societyListData &&
      societyListData.societyListData &&
      societyListData.societyListData.data) ||
    null;

  const [complaintFilters, setComplaintFilters] = useState({
    status: null,
    startDate: null,
    endDate: null,
    societyId: null,
    societyName: null,
  });
  const [rangeValue, setRangeValue] = useState([null, null]);
  useEffect(() => {
    callsocietyComplaintData({
      startDate: null,
      endDate: null,
      status: null,
      societyId: null,
    });
    calldashboardPresidentCountData();
    callsocietyListData({
      type: null,
      startDate: null,
      endDate: null,
      status: null,
    });
  }, []);
  const society_name = totalSocietyList?.map((item) => ({
    value: item.name,
    lable: item.name,
  }));
  const handelComplaintStatusType = (value) => {
    setComplaintFilters((prev) => ({
      ...prev,
      status: value,
    }));
  };
  const handelSocietyName = (value) => {
    const selected_id = totalSocietyList.find(
      (client) => client.name === value
    );
    const societyID = selected_id ? selected_id._id : null;
    setComplaintFilters((prev) => ({
      ...prev,
      societyId: societyID,
      societyName: value,
    }));
  };
  const handleFilterDateChange = (dates) => {
    setComplaintFilters((prev) => ({
      ...prev,
      startDate: dates ? dates[0].format("YYYY-MM-DD") : null,
      endDate: dates ? dates[1].format("YYYY-MM-DD") : null,
    }));
    setRangeValue(dates);
  };

  useEffect(() => {
    callsocietyComplaintData(complaintFilters);
  }, [complaintFilters]);

  const ActionMenu = (e) => {
    return (
      <Menu>
        <Menu.Item key="1" className="no-hover">
          <p>Mark As</p>
        </Menu.Item>
      </Menu>
    );
  };
  const societies_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Complaint",
      dataIndex: "content",
      key: "content",
      render: (text) => {
        const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
        return (
          <Tooltip placement="top" title={capitalizedText}>
            <div className="complaint-container">
              <p
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {capitalizedText}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Wing",
      dataIndex: "wingName",
      key: "wingName",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Flat Number",
      dataIndex: "flatNumber",
      key: "flatNumber",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Priority Level",
      dataIndex: "priority",
      key: "priority",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const formattedStatus =
          status.charAt(0).toUpperCase() + status.slice(1);
        const color =
          status === "pending"
            ? "red"
            : status === "in-progress"
            ? "blue"
            : status === "resolved"
            ? "green"
            : status === "complete"
            ? "purple"
            : status === "reopen"
            ? "orange"
            : "default";

        return <Tag color={color}>{formattedStatus}</Tag>;
      },
    },
  ];

  const filteredComplaints = complaintData?.filter((item) => {
    const matchesSearchQuery = item?.content
      ?.toLowerCase()
      .includes(searchText.toLowerCase());

    return matchesSearchQuery;
  });

  const complaint_table_data = filteredComplaints?.map((item, index) => ({
    key: index + 1,
    content: item.content,
    flatNumber: item.flatNumber || "N/a",
    wingName: item.wingName || "N/a",
    owner: item.owner || "N/a",
    status: item.status,
    priority: item.priority || "N/a",
    societyName: item.societyName || "N/a",
    date: moment(item.date).format("DD/MM/YYYY"),
  }));

  const handelComplaintFilterClear = () => {
    setComplaintFilters({
      status: null,
      startDate: null,
      endDate: null,
      societyId: null,
    });
    setSearchText("");
    setRangeValue([null, null]);
  };
  const loading = societyComplaintData.isLoading;

  const isClearDisabled =
    !complaintFilters.status &&
    !complaintFilters.startDate &&
    !complaintFilters.societyId &&
    !searchText;

  return (
    <React.Fragment>
      {loading && <PageLoader />}
      <ComplaintsComponent
        handelComplaintStatusType={handelComplaintStatusType}
        complaintFilters={complaintFilters}
        handleFilterDateChange={handleFilterDateChange}
        societies_table_columns={societies_table_columns}
        complaint_table_data={complaint_table_data}
        setSearchText={setSearchText}
        complaint_count={complaint_count}
        handelComplaintFilterClear={handelComplaintFilterClear}
        searchText={searchText}
        society_name={society_name}
        handelSocietyName={handelSocietyName}
        rangeValue={rangeValue}
        isClearDisabled={isClearDisabled}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  societyComplaintData: state.societyComplaintData,
  dashboardPresidentCountData: state.dashboardPresidentCountData,
  societyListData: state.societyListData,
});

const mapDispatchToProps = (dispatch) => ({
  callsocietyComplaintData: (filters) => dispatch(societyComplaint(filters)),
  calldashboardPresidentCountData: () => dispatch(dashboardPresidentCount()),
  callsocietyListData: (filters) => dispatch(societyList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Complaints);
